/* eslint-disable */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends =
    Object.assign ||
    function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(
        Object.getOwnPropertySymbols(source).filter(function(sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        })
      );
    }

    ownKeys.forEach(function(key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest()
  );
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (
      var _i = arr[Symbol.iterator](), _s;
      !(_n = (_s = _i.next()).done);
      _n = true
    ) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var isArray = function isArray(arg) {
  return Object.prototype.toString.call(arg) === "[object Array]";
};

var EventEmitter =
  /*#__PURE__*/
  (function() {
    function EventEmitter() {
      var events =
        arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, EventEmitter);

      this.events = events;

      _defineProperty(this, "hop", void 0);

      this.hop = this.events.hasOwnProperty;
    }

    _createClass(EventEmitter, [
      {
        key: "on",
        value: function on(event, handler) {
          var _this = this;

          var events = isArray(event) ? event : event.split(" ");

          if (events.length > 1) {
            events.forEach(function(evt) {
              _this.on(evt, handler);
            });
          }

          if (typeof event === "string") {
            if (!this.hop.call(this.events, event)) {
              this.events[event] = [];
            }

            this.events[event].push(handler);
          }
        }
      },
      {
        key: "emit",
        value: function emit(event, ctx) {
          var _this2 = this;

          var events = isArray(event) ? event : event.split(" ");

          if (events.length > 1) {
            events.forEach(function(evt) {
              _this2.emit(evt, ctx);
            });
          }

          if (typeof event === "string") {
            if (!this.hop.call(this.events, event)) {
              return;
            }

            this.events[event].forEach(function(item) {
              item(ctx || {});
            });
          }
        }
      }
    ]);

    return EventEmitter;
  })();

var version = "0.3.2";

var defaultOptions = {
  version: version,
  type: "info",
  once: true,
  position: ["right", "bottom"],
  duration: 5000,
  maxItems: null,
  progress: true,
  progressOptions: {
    position: "top",
    color: "#737373",
    easing: "linear"
  },
  animation: true,
  animationOptions: {
    duration: 1000,
    animateIn: "fadeIn",
    animateOut: "fadeOut"
  },
  addNotify: "auto",
  styles: {
    width: 300,
    textAlign: "center",
    boxShadow: "2px 4px 12px rgba(0, 0, 0, 0.10)",
    margin: 15,
    padding: [15, 10],
    borderRadius: 3,
    zIndex: 999,
    typeStyle: {
      success: "#dff0d8",
      warning: "#fcf8e3",
      error: "#f2dede",
      info: "#d9edf7"
    }
  },
  className: {
    main: "notify",
    wrap: "notify-wrapper",
    progress: "notify__progress"
  },
  templates: [
    {
      name: "title",
      className: "notify__title",
      tpl:
        '\n        <div class="{% class %}">\n          <b>{% title %}</b>\n        </div>\n      '
    },
    {
      name: "message",
      className: "notify__message",
      tpl:
        '\n        <div class="{% class %}">\n          <span>{% message %}</span>\n        </div>\n      '
    }
  ]
};

/**
 * For Notifications
 */
var SHOW_BEFORE = "show:before";
var SHOW_AFTER = "show:after";
var REMOVE = "remove";
/**
 * For Timer
 */

var TIME_START = "time:start";
var TIME_STOP = "time:stop";
var TIME_END = "time:end";
/**
 * For Notify
 */

var MOUNT_AFTER = "mount:after";
var MOUNT_BEFORE = "mount:before";
var UNMOUNT_AFTER = "unmount:after";
var UNMOUNT_BEFORE = "unmount:before";

var Timer =
  /*#__PURE__*/
  (function() {
    function Timer(time) {
      _classCallCheck(this, Timer);

      this.time = time;

      _defineProperty(this, "timerId", void 0);

      _defineProperty(this, "remaining", void 0);

      _defineProperty(this, "timeEnd", void 0);

      _defineProperty(this, "active", void 0);

      _defineProperty(this, "_event", void 0);

      this.timerId = null;
      this.remaining = this.time;
      this.timeEnd = null;
      this.active = false;
      this._event = new EventEmitter();
    }

    _createClass(Timer, [
      {
        key: "start",
        value: function start() {
          var _this = this;

          this.active = true;
          this.timeEnd = new Date().getTime() + this.remaining;

          this._event.emit(
            TIME_START,
            _objectSpread({}, this, {
              type: TIME_START
            })
          );

          this.timerId = setTimeout(function() {
            clearTimeout(_this.timerId);
            _this.active = false;

            _this._event.emit(
              TIME_END,
              _objectSpread({}, _this, {
                type: TIME_END
              })
            );
          }, this.remaining);
        }
      },
      {
        key: "stop",
        value: function stop() {
          if (this.timeEnd && this.active) {
            clearTimeout(this.timerId);
            this.remaining = this.timeEnd - new Date().getTime();
            this.active = false;
            this.timeEnd = null;

            this._event.emit(
              TIME_STOP,
              _objectSpread({}, this, {
                type: TIME_STOP
              })
            );
          } else {
            throw Error("The timer is not running.");
          }
        }
      },
      {
        key: "on",
        value: function on(event, ctx) {
          this._event.on(event, ctx);
        }
      },
      {
        key: "reset",
        value: function reset() {
          clearTimeout(this.timerId);
          this.remaining = this.time;
          this.active = false;
          this.timeEnd = null;
        }
      },
      {
        key: "isActive",
        get: function get() {
          return this.active;
        }
      },
      {
        key: "getRemainingPercent",
        get: function get() {
          return ((this.remaining / this.time) * 100) ^ 0;
        }
      },
      {
        key: "getRemaining",
        get: function get() {
          return this.remaining;
        }
      }
    ]);

    return Timer;
  })();

var random = Math.random,
  pow = Math.pow;
var isColor = function isColor(color) {
  return (
    color.substring(0, 1) === "#" ||
    color.substring(0, 3) === "rgb" ||
    color.substring(0, 3) === "hsl"
  );
};
var generateId = function generateId() {
  return pow((random() * new Date().getTime()) ^ 0, 2).toString(32);
};
var capitalize = function capitalize(str) {
  if (!str) return str;
  return str[0].toUpperCase() + str.slice(1);
};

var template = function(tpl, options) {
  tpl = tpl.replace(/\{#[^]*?#\}/g, "");
  var matches = tpl.match(/\{\%\s*[a-zA-Z0-9._/:-]+?\s*\%\}/g);

  if (matches !== null) {
    matches.forEach(function(piece) {
      for (var key in options) {
        if (new RegExp(key).test(piece)) {
          tpl = tpl.replace(piece, options[key]);
        }
      }
    });
  }

  return tpl;
};

var styleСonversionSides = function styleСonversionSides(prop) {
  if (isArray(prop)) {
    var result = "";

    for (var i = 0; i < prop.length; i++) {
      if (i < 4) {
        result += "".concat(prop[i], "px ");
      } else {
        break;
      }
    }

    return result;
  }

  return typeof prop === "string" ? prop : prop + "px";
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === "undefined") {
    return;
  }

  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.type = "text/css";

  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css =
  "@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.fadeIn {\n  animation-name: fadeIn; }\n\n@keyframes fadeOut {\n  from {\n    opacity: 1; }\n  to {\n    opacity: 0; } }\n\n.fadeOut {\n  animation-name: fadeOut; }\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0); }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0); } }\n\n.fadeInLeft {\n  animation-name: fadeInLeft; }\n\n@keyframes fadeOutLeft {\n  from {\n    opacity: 1; }\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0); } }\n\n.fadeOutLeft {\n  animation-name: fadeOutLeft; }\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0); }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0); } }\n\n.fadeInRight {\n  animation-name: fadeInRight; }\n\n@keyframes fadeOutRight {\n  from {\n    opacity: 1; }\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0); } }\n\n.fadeOutRight {\n  animation-name: fadeOutRight; }\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0); }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0); } }\n\n.fadeInDown {\n  animation-name: fadeInDown; }\n\n@keyframes fadeOutDown {\n  from {\n    opacity: 1; }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0); } }\n\n.fadeOutDown {\n  animation-name: fadeOutDown; }\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0); }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0); } }\n\n.fadeInUp {\n  animation-name: fadeInUp; }\n\n@keyframes fadeOutUp {\n  from {\n    opacity: 1; }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0); } }\n\n.fadeOutUp {\n  animation-name: fadeOutUp; }\n\n.animated {\n  animation-duration: 1s;\n  animation-fill-mode: both; }\n";
styleInject(css);

var Notify =
  /*#__PURE__*/
  (function() {
    function Notify(notify, options, ctx) {
      _classCallCheck(this, Notify);

      this.notify = notify;
      this.options = options;
      this.ctx = ctx;

      _defineProperty(this, "ID", void 0);

      _defineProperty(this, "target", void 0);

      _defineProperty(this, "active", void 0);

      _defineProperty(this, "timer", void 0);

      _defineProperty(this, "_event", void 0);

      this.ID = generateId();
      this.target = null;
      this.active = false;
      this.timer = new Timer(this.notify.duration || this.options.duration);
      this._event = new EventEmitter();
    }

    _createClass(Notify, [
      {
        key: "mount",
        value: function mount(elem) {
          var _this = this;

          this._event.emit(MOUNT_AFTER, this);

          elem.insertBefore(this.createNotify(), this.addNotify(elem));
          setTimeout(function() {
            _this.active = true;

            _this.timer.start();
          }, 50);

          if (this.target && this.options.animation) {
            this.target.classList.add("animated");
            this.target.classList.add(this.options.animationOptions.animateIn);
          }

          this._event.emit(MOUNT_BEFORE, this);
        }
      },
      {
        key: "unmount",
        value: function unmount() {
          this._event.emit(UNMOUNT_AFTER, this);

          this.active = false;

          if (this.target && this.options.animation) {
            this.target.classList.add("animated");
            this.target.classList.add(this.options.animationOptions.animateOut);
          } else {
            this.remove();
          }

          this._event.emit(UNMOUNT_BEFORE, this);
        }
      },
      {
        key: "on",
        value: function on(event, ctx) {
          this._event.on(event, ctx);
        }
      },
      {
        key: "remove",
        value: function remove() {
          if (this.target && this.target.parentNode && !this.active) {
            this.target.parentNode.removeChild(this.target);
          }

          this.ctx.remove(this.ID);
        }
      },
      {
        key: "progressBar",
        value: function progressBar(evt) {
          if (this.target) {
            var progress = this.target.querySelector(
              "." + this.options.className.progress
            );

            if (evt.type === TIME_STOP && progress) {
              progress.style.width = this.timer.getRemainingPercent + "%";
            }

            if (evt.type === TIME_START && progress) {
              progress.style.width = "0%";
              progress.style.transition = "width "
                .concat(this.timer.getRemaining, "ms ")
                .concat(this.options.progressOptions.easing);
            }
          }
        }
      },
      {
        key: "animateEnd",
        value: function animateEnd() {
          var wrapClassList = this.target.classList;
          var _this$options$animati = this.options.animationOptions,
            animateIn = _this$options$animati.animateIn,
            animateOut = _this$options$animati.animateOut;

          if (wrapClassList.contains(animateIn)) {
            wrapClassList.remove("animated");
            wrapClassList.remove(animateIn);
          }

          if (wrapClassList.contains(animateOut)) {
            this.remove();
          }
        }
      },
      {
        key: "addNotify",
        value: function addNotify(elem) {
          var posY = this.options.position[1];
          var addNotify = this.options.addNotify;

          if (!addNotify || addNotify === "auto") {
            return posY === "top" ? null : elem.firstChild;
          }

          return addNotify === "append" ? null : elem.firstChild;
        }
      },
      {
        key: "hover",
        value: function hover(evt) {
          if (evt.type === "mouseenter") {
            this.timer.stop();
          }

          if (evt.type === "mouseleave") {
            this.timer.start();
          }
        }
      },
      {
        key: "createNotify",
        value: function createNotify() {
          var _this2 = this;

          var main = this.options.className.main;
          var animationDuration =
            this.options.animationOptions.duration === "string"
              ? this.options.animationOptions.duration
              : this.options.animationOptions.duration + "ms";
          this.target = document.createElement("div");
          this.target.className = main;
          this.target.id = this.ID;
          this.target.style.cssText = "\n      position: relative;\n      box-sizing: border-box;\n      box-shadow: "
            .concat(this.options.styles.boxShadow, ";\n      padding: ")
            .concat(
              styleСonversionSides(this.options.styles.padding),
              ";\n      border-radius: "
            )
            .concat(
              styleСonversionSides(this.options.styles.borderRadius),
              ";\n      margin: "
            )
            .concat(
              styleСonversionSides(this.options.styles.margin),
              ";\n      background: "
            )
            .concat(this.color, ";\n      text-align: ")
            .concat(
              this.options.styles.textAlign,
              ";\n      -webkit-animation-duration: "
            )
            .concat(animationDuration, ";\n      animation-duration: ")
            .concat(animationDuration, ";\n      overflow: hidden;\n    ");
          this.options.templates.forEach(function(templateElem) {
            var name = templateElem.name,
              tpl = templateElem.tpl,
              className = templateElem.className;
            var text = _this2.notify[name];

            if (_this2.notify[name] && _this2.target) {
              var _template;

              _this2.target.innerHTML += template(
                tpl,
                ((_template = {}),
                _defineProperty(_template, name, text),
                _defineProperty(_template, "class", className || name),
                _template)
              );
            }
          }, this);

          if (this.options.progress) {
            var progress = document.createElement("div");
            progress.className = this.options.className.progress;
            progress.style.cssText = "\n        position: absolute;\n        "
              .concat(
                this.options.progressOptions.position,
                ": 0;\n        left: 0;\n        height: 2px;\n        width: 100%;\n        background-color: "
              )
              .concat(
                isColor(this.options.progressOptions.color)
                  ? this.options.progressOptions.color
                  : "#737373",
                ";\n      "
              );
            this.target.insertBefore(progress, this.target.firstChild);
            this.timer.on([TIME_START, TIME_STOP], this.progressBar.bind(this));
          }

          this.timer.on(TIME_END, this.unmount.bind(this));
          this.target.addEventListener("mouseenter", this.hover.bind(this));
          this.target.addEventListener("mouseleave", this.hover.bind(this));
          this.target.addEventListener(
            "animationend",
            this.animateEnd.bind(this)
          );
          this.target.addEventListener("click", this.unmount.bind(this));
          return this.target;
        }
      },
      {
        key: "id",
        get: function get() {
          return this.ID;
        }
      },
      {
        key: "isActive",
        get: function get() {
          return this.active;
        }
      },
      {
        key: "color",
        get: function get() {
          var types = this.options.styles.typeStyle;
          var type = this.notify.type || this.options.type;
          var result = isColor(type) ? type : types[type];

          if (result && typeof result === "string" && isColor(result)) {
            return result;
          } else {
            throw new TypeError(
              'In "type" you can pass either one of the ready types ["success", "warning" "error", "info"] or specify the color;'
            );
          }
        }
      }
    ]);

    return Notify;
  })();

var isObject = function isObject(obj) {
  return obj instanceof Object && !(obj instanceof Array);
};
var mergeOptions = function mergeOptions(defaults, settings) {
  var object = _extends({}, defaults, settings);

  var mergeObject = function mergeObject(obj, objEnd) {
    for (var key in obj) {
      if (isObject(obj[key]) && objEnd[key]) {
        objEnd[key] = _extends({}, obj[key], objEnd[key]);
        mergeObject(obj[key], objEnd[key]);
      }
    }

    return objEnd;
  };

  return mergeObject(defaults, object);
};

var Notifications =
  /*#__PURE__*/
  (function() {
    function Notifications(options) {
      _classCallCheck(this, Notifications);

      _defineProperty(this, "options", void 0);

      _defineProperty(this, "notifications", void 0);

      _defineProperty(this, "queue", void 0);

      _defineProperty(this, "targetWrap", void 0);

      _defineProperty(this, "_event", void 0);

      this.options = mergeOptions(defaultOptions, options);
      this.targetWrap = null;
      this.notifications = [];
      this.queue = [];
      this._event = new EventEmitter(); // console.log(this.options);
    }

    _createClass(Notifications, [
      {
        key: "init",
        value: function init() {
          this.targetWrap = document.querySelector(
            "."
              .concat(this.options.className.wrap, ".")
              .concat(this.genClassName)
          );

          if (!this.targetWrap) {
            this.createWrap();
          }
        }
      },
      {
        key: "show",
        value: function show(notify) {
          if (this.options.once) {
            var redo = this.notifications.some(function(elem) {
              return JSON.stringify(elem.notify) === JSON.stringify(notify);
            });
            if (redo) return;
          }

          if (
            this.options.maxItems &&
            this.notifications.length >= this.options.maxItems
          ) {
            this.queue.push(notify);
            return;
          }

          this._event.emit(
            SHOW_AFTER,
            _objectSpread({}, this, {
              type: SHOW_AFTER
            })
          );

          this.notifications.push(new Notify(notify, this.options, this));

          if (this.notifications.length) {
            if (!this.targetWrap) {
              this.init();
            }

            if (this.targetWrap) {
              var notifyElem = this.notifications[
                this.notifications.length - 1
              ];
              notifyElem.mount(this.targetWrap);

              this._event.emit(
                SHOW_BEFORE,
                _objectSpread({}, this, {
                  type: SHOW_BEFORE,
                  createElement: notifyElem
                })
              );
            }
          }
        }
      },
      {
        key: "on",
        value: function on(event, ctx) {
          this._event.on(event, ctx);
        }
      },
      {
        key: "remove",
        value: function remove(id) {
          var idx = 0;

          for (var i = 0; i < this.notifications.length; i++) {
            if (this.notifications[i].id === id) {
              idx = i;
              break;
            }
          }

          if (idx >= 0) {
            if (this.notifications[idx].isActive) {
              this.notifications[idx].unmount();
            } else {
              this.notifications.splice(idx, 1);

              if (
                this.options.maxItems &&
                this.queue.length &&
                this.notifications.length < this.options.maxItems
              ) {
                this.show(this.queue[0]);
                this.queue.shift();
              }
            }
          } else {
            throw new Error("There is no element with this id");
          }

          if (
            !this.notifications.length &&
            this.targetWrap &&
            this.targetWrap.parentNode
          ) {
            this.targetWrap.parentNode.removeChild(this.targetWrap);
            this.targetWrap = null;
          }

          this._event.emit(
            REMOVE,
            _objectSpread({}, this, {
              type: REMOVE
            })
          );
        }
      },
      {
        key: "createWrap",
        value: function createWrap() {
          this.targetWrap = document.createElement("div");
          this.targetWrap.classList.add(this.options.className.wrap);
          this.targetWrap.classList.add(this.genClassName);
          this.targetWrap.style.cssText = this.genStyles;
          document.body.appendChild(this.targetWrap);
        }
      },
      {
        key: "genClassName",
        get: function get() {
          var _this$options$positio = _slicedToArray(this.options.position, 2),
            x = _this$options$positio[0],
            y = _this$options$positio[1];

          return this.options.className.wrap + "-" + x + capitalize(y);
        }
      },
      {
        key: "genStyles",
        get: function get() {
          var _this$options$positio2 = _slicedToArray(this.options.position, 2),
            x = _this$options$positio2[0],
            y = _this$options$positio2[1];

          var _this$options$styles = this.options.styles,
            width = _this$options$styles.width,
            zIndex = _this$options$styles.zIndex;
          var posX =
            x === "center"
              ? "left: 50%; transform: translateX(-50%);"
              : x === "left"
              ? "left: 0;"
              : "right: 0;";
          var posY = y === "top" ? "top: 0;" : "bottom: 0;";
          return "\n      box-sizing: border-box;\n      position:fixed;\n      width:"
            .concat(width === "max" ? "100%" : width + "px", ";\n      ")
            .concat(posX, "\n      ")
            .concat(posY, "\n      z-index: ")
            .concat(zIndex);
        }
      }
    ]);

    return Notifications;
  })();

export default Notifications;
